<template>
  <div class="u-watermark">
    <div
      v-for="i in 50"
      class="u-watermark-row"
    >
      <div
        v-for="i in 10"
        class="u-watermark-col"
      >{{text}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['text']
}
</script>
<style lang="scss" scope>
@import '../../assets/style/var';
.u-watermark {
  position: fixed;
  width: 100vw;
  height: 120vh;
  overflow: hidden;
  z-index: 200;
  top: -100px;
  left: 0;
  pointer-events: none;
  color: rgba(255, 255, 255, 0.1);
  font-size: 0.28rem;
  font-family: 'PingFangSC-Regular';

  &-row {
    width: 120vw;
    display: flex;

    margin-bottom: px2rem(140);
    transform: translateX(-100px) rotate(-30deg);
    .u-watermark-col {
      display: inline-block;
      white-space: nowrap;
      margin-right: px2rem(140);
    }
  }
}
</style>
